import React from "react"

import { NotificationManager } from "react-notifications"

import { gql, useMutation } from "hooks/urql"

type Student = {
  id: string
  fullName: string
  showPath: string
}

type StudentsListProps = {
  acrClassId: string
  students: Student[]
}

const StudentsList: React.FC<StudentsListProps> = ({
  acrClassId,
  students,
}) => {
  const [, removeStudent]: any[] = useMutation(removeStudentMutation)
  const handleRemoveStudent = (studentId: string) => {
    removeStudent({
      acrClassId,
      studentId,
    })
      .then(
        (response: any) => {
          const { failures } = response.data.removeAcrClassStudent
          if (failures.length > 0) {
            NotificationManager.error(failures[0].message)
          } else {
            window.location.reload()
          }
        },
        () => NotificationManager.error("Something went wrong")
      )
      .catch(() => NotificationManager.error("Something went wrong"))
  }

  if (students.length === 0) {
    return <p className="italic">No Students Enrolled</p>
  }

  return (
    <div>
      <table className="table">
        <thead>
          <tr>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          {students.map(student => (
            <tr key={student.id}>
              <td>
                <a href={student.showPath}>{student.fullName}</a>
              </td>
              <td>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleRemoveStudent(student.id)}
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

const removeStudentMutation = gql`
  mutation ($acrClassId: ID!, $studentId: ID!) {
    removeAcrClassStudent(acrClassId: $acrClassId, studentId: $studentId) {
      failures {
        message
      }
    }
  }
`

export default StudentsList
